let pageHost = window.location.host.split('.');
let len = pageHost.length;

const hostName =  pageHost[len - 2] + '.' + pageHost[len - 1];

export default hostName;